export enum LDFlagKeys {
  addressFirst = 'address-first',
  aiChat = 'ai-chat',
  communicationUnavailable = 'communication-unavailable',
  installerPageCuts = 'installer-page-cuts',
  otpVerificationDisabled = 'otp-verification-disabled',
  showCad = 'show-cad',
  showCadFullscreen = 'show-cad-fullscreen',
  useAuroraProductionValues = 'use-aurora-production-values',
}

export type LDFlags = {
  addressFirst: boolean;
  aiChat: boolean;
  communicationUnavailable: boolean;
  installerPageCuts: boolean;
  otpVerificationDisabled: boolean;
  showCad: boolean;
  showCadFullscreen: boolean;
  useAuroraProductionValues: boolean;
};

export type LDFlagsDashCase = {
  [LDFlagKeys.addressFirst]: boolean;
  [LDFlagKeys.aiChat]: boolean;
  [LDFlagKeys.communicationUnavailable]: boolean;
  [LDFlagKeys.installerPageCuts]: boolean;
  [LDFlagKeys.otpVerificationDisabled]: boolean;
  [LDFlagKeys.showCad]: boolean;
  [LDFlagKeys.showCadFullscreen]: boolean;
  [LDFlagKeys.useAuroraProductionValues]: boolean;
};

export const toFlagsCamelCase = (flags: Partial<LDFlagsDashCase>): Partial<LDFlags> => {
  return Object.fromEntries(
    Object.entries(LDFlagKeys)
      .filter(([_, value]) => value in flags)
      .map(([key, value]) => [key, flags[value as keyof LDFlagsDashCase]])
  );
};

export const toFlagKeys = (flags: Partial<LDFlags>): Partial<LDFlagsDashCase> => {
  return Object.fromEntries(Object.entries(LDFlagKeys).map(([key, value]) => [value, flags[key as keyof LDFlags]]));
};

export type Experiment = { name: LDFlagKeys; variation: string };

export const toExperimentVariation = (value: unknown, variationIndex?: number | null): string => {
  if (typeof value === 'object' && value !== null) {
    return (value as Record<string, string>).label ?? `variation ${variationIndex ?? 0}`;
  }
  return String(value);
};

export const getUrlOverrides = (params: URLSearchParams): Partial<LDFlagsDashCase> => {
  const keyValues = Object.values(LDFlagKeys)
    .filter((key) => params.has(key))
    .map((key) => {
      const value = params.get(key);

      if (value != null && ['', 'true', 'false'].includes(value)) {
        return [key, value !== 'false'];
      }

      return [key, value];
    });

  return Object.fromEntries(keyValues);
};
